"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DockNav = exports.DockButton = exports.DockDivider = exports.DockContainer = exports.DockBar = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DockBar = function DockBar(_ref) {
  var children = _ref.children;
  return _react.default.createElement("div", {
    className: "co-dock__bar"
  }, children);
};

exports.DockBar = DockBar;

var DockContainer = function DockContainer(_ref2) {
  var children = _ref2.children,
      maximal = _ref2.maximal;
  var classNames = {
    'co-dock__container': true,
    'co-dock__container--maximal': maximal
  };
  return _react.default.createElement(_styler.default, {
    classNames: classNames
  }, function (styles) {
    return _react.default.createElement("div", {
      className: styles
    }, children);
  });
};

exports.DockContainer = DockContainer;

var DockNav = function DockNav(_ref3) {
  var children = _ref3.children;
  return _react.default.createElement("div", {
    className: "co-dock__nav"
  }, children);
};

exports.DockNav = DockNav;

var DockDivider = function DockDivider() {
  return _react.default.createElement("div", {
    className: "co-dock__divider"
  });
};

exports.DockDivider = DockDivider;

var DockButton = function DockButton(_ref4) {
  var children = _ref4.children,
      active = _ref4.active,
      appName = _ref4.appName,
      onClick = _ref4.onClick,
      props = _objectWithoutProperties(_ref4, ["children", "active", "appName", "onClick"]);

  return _react.default.createElement(_styler.default, {
    classNames: "co-dock__button",
    modifiers: {
      active: active
    }
  }, function (styles) {
    return _react.default.createElement("button", _extends({
      className: styles,
      onClick: onClick
    }, (0, _getNativeProps.default)(props)), children);
  });
};

exports.DockButton = DockButton;
DockBar.propTypes = {
  children: _propTypes.any.isRequired
};
DockNav.propTypes = {
  children: _propTypes.any.isRequired
};
DockContainer.propTypes = {
  children: _propTypes.any.isRequired,
  maximal: _propTypes.bool
};
DockButton.propTypes = {
  children: _propTypes.any.isRequired,
  active: _propTypes.bool,
  appName: _propTypes.string,
  onClick: _propTypes.func
};
DockButton.defaultProps = {
  appName: '',
  onClick: function onClick() {}
};
DockBar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DockBar",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": ""
    }
  }
};
DockContainer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DockContainer",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": ""
    },
    "maximal": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};
DockDivider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DockDivider"
};
DockButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DockButton",
  "props": {
    "appName": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": ""
    },
    "active": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};
DockNav.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DockNav",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": ""
    }
  }
};